import React, { useState } from "react";
import DepartMentList from "./Department/mainDepartment";
import TargetList from "./Targetssalary/mainTargets";
import { ROLE } from "../../../../../utils/Constant";
import EmpList from "./Employee/mainEmp";
import AllAttendence from "./Employee/allempattendence";
const MainEmp = ({ admin }) => {
    const [viewType, setviewType] = useState('emp')
    const [editData, seteditData] = useState('')

    const editHandler = (data) => {
        console.log(data)
        if (data.id) {
            seteditData(data)
            setviewType('add')
        }



    }
    const ChangeScreen = (type) => {
        seteditData('')
        setviewType(type)
    }
    return (
        <div className="container-fluid">
            {/* <div style={{ display: 'flex', textAlign: 'center' }}>
                <div onClick={() => ChangeScreen('list')} style={{ color: viewType === 'list' ? '#fff' : '#000', background: viewType === 'list' ? '#337ab7' : '#f4f3f1', padding: '10px', borderRadius: '5px', width: '40px', height: '40px', cursor: 'pointer' }}> <i className="fa fa-list" ></i></div>&nbsp;&nbsp;

            </div> */}
            <div className="row fixed-top" style={{ marginTop: '76px', display: 'flex', width: '100%' ,zIndex:'10' }}>

                <div className="" onClick={() => setviewType('emp')} style={{ borderBottom: viewType === 'emp' ? '2px solid #064254' : '', background: viewType === 'emp' ? '#064254' : '#DBE9FF', padding: viewType === 'emp' ? '13px' : '12.2px', textAlign: 'center', color: viewType === 'emp' ? '#fff' : '#000', cursor: 'pointer', width: '25%' }}>
                    Employees

                </div>
                {
                    admin.rolelist.indexOf(ROLE.VIEW_EMPLOYEE_ATTENDENCE) >= 0 && (
                        <div className="" onClick={() => setviewType('attendence')} style={{ borderBottom: viewType === 'attendence' ? '2px solid #064254' : '', background: viewType === 'attendence' ? '#064254' : '#DBE9FF', padding: viewType === 'attendence' ? '13px' : '12.2px', textAlign: 'center', color: viewType === 'attendence' ? '#fff' : '#000', cursor: 'pointer', width: '25%' }}>
                    All Employee Attendance

                </div>
                )}
                <div className="" onClick={() => setviewType('department')} style={{ borderBottom: viewType === 'department' ? '2px solid #064254' : '', background: viewType === 'department' ? '#064254' : '#DBE9FF', padding: viewType === 'department' ? '13px' : '12.2px', textAlign: 'center', color: viewType === 'department' ? '#fff' : '#000', cursor: 'pointer', width: '25%' }}>
                    Departments

                </div>
                <div className="" onClick={() => setviewType('target')} style={{ borderBottom: viewType === 'target' ? '2px solid #064254' : '', background: viewType === 'target' ? '#064254' : '#DBE9FF', padding: viewType === 'target' ? '13px' : '12.2px', textAlign: 'center', color: viewType === 'target' ? '#fff' : '#000', cursor: 'pointer', width: '25%' }}>
                    Targets

                </div>

            </div>
            <div style={{ marginTop: '50px' }}>
                {viewType === 'emp' ?
                    <EmpList showButton={false} admin={admin} editHandler={editHandler} />
                    : ""}
                {viewType === 'department' ?
                    <DepartMentList showButton={false} admin={admin} editData={editData} />
                    : ""}
                {viewType === 'target' ?
                    <TargetList showButton={false} admin={admin} editData={editData} />
                    : ""}
                {viewType === 'attendence' ?
                    <AllAttendence showButton={false} admin={admin} editData={editData} />
                    : ""}
            </div>

        </div>
    )
}
export default MainEmp